type ProfileReadValueProps = {
  label: string;
  value?: string | null;
};

export function ProfileReadValue({ label, value }: ProfileReadValueProps) {
  const text = value?.trim() ? value : '—';

  return (
    <div className="profile-read-value">
      <span className="profile-read-value__label">{label}</span>
      <p className="profile-read-value__text">{text}</p>
    </div>
  );
}
